import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-title" }
const _hoisted_2 = { class: "p-4" }
const _hoisted_3 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_4 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}

import ModalView from "@/components/ModalView.vue";



export default /*#__PURE__*/_defineComponent({
  props: {
    isVisible: { type: Boolean },
    loading: { type: Boolean },
    title: null,
    message: null,
    messageSubtitle: null,
    confirmButtonText: null,
    cancelButtonText: null
  },
  emits: ["hide-modal", "confirm", "cancel"],
  setup(__props: any, { emit }) {

const props = __props as {
  isVisible: boolean;
  loading: boolean;
  title: string;
  message: string;
  messageSubtitle?: string;
  confirmButtonText: string;
  cancelButtonText: string;
}





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalView, {
    "is-visible": __props.isVisible,
    onHideModal: _cache[2] || (_cache[2] = ($event: any) => (emit('hide-modal')))
  }, {
    header: _withCtx(() => [
      _createElementVNode("h5", _hoisted_1, _toDisplayString(props.title), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, _toDisplayString(props.message), 1),
        (__props.messageSubtitle != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(props.messageSubtitle), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn btn-outline-primary me-2", { disabled: __props.loading }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel')))
      }, _toDisplayString(__props.cancelButtonText), 3),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn btn-primary", { disabled: __props.loading }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('confirm')))
      }, [
        (__props.loading)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(__props.confirmButtonText), 1)
      ], 2)
    ]),
    _: 1
  }, 8, ["is-visible"]))
}
}

})